import { Route, Routes } from "react-router-dom";
import { Gallery } from "./pages/Gallery";
import { Admin } from "./pages/Admin";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Gallery />} />
      <Route path="/admin" element={<Admin />} />
      <Route
        path="*"
        element={
          <div className="app">
            <div className="grain" aria-hidden />
            <div className="empty">∅ not found</div>
          </div>
        }
      />
    </Routes>
  );
}
